/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Forderung (Förderung)
 * 
 * 401130001 = Begutachtung (Begutachtung)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAcePortaltyp {
 Forderung = 401130000,
 Begutachtung = 401130001
}

marker([
    "Enum.GlobalEnumsAcePortaltyp.Forderung",
    "Enum.GlobalEnumsAcePortaltyp.Begutachtung"
]);

export namespace GlobalEnumsAcePortaltyp
{
    class DataSets
    {
        static GlobalEnumsAcePortaltypDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Forderung", 401130000, "Förderung"),
            new EnumValue("Begutachtung", 401130001, "Begutachtung"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAcePortaltypDataSet;
    }
}
